<template>
    <div class="com-famous-comment-item-second dsp-flex">
        <div class="com-famous-cis-avatar">
            <img class="com-famous-cis-img" v-bind:src="secondItemData.userAvatar == '' ? avatarUrl : secondItemData.userAvatar" alt="">
        </div>
        <div class="com-famous-ci-content">
            <div class="com-famous-cis-title">
                <div class="com-famous-cis-title-title"><span>{{secondItemData.userName}}</span> <span class="com-famous-cis-reply">回</span> <span>{{secondItemData.toName}}</span></div>
                <span class="com-famous-cic-good" v-if="!secondItemData.isDelete" @click="clickMore">
                    <i class="iconfont icon-more"></i>
                </span>
            </div>
            <div v-if="secondItemData.isDelete" class="com-famous-cic-content-delete">
                <p>该评论已删除</p>
            </div>
            <div v-else class="com-famous-cis-content">
                <p v-html="UTILS.getBreakLineByText(secondItemData.msg)"></p>
            </div>
            <div class="com-famous-cic-note">
                <span class="com-famous-cic-date">{{secondItemData.timeStr}}</span>
                <span v-if="!secondItemData.isDelete" class="com-famous-cic-good-2" @click="clickLike">
                    <span v-if="secondItemData.likeNum != 0" class="com-famous-cic-good-num">{{secondItemData.likeNum}}</span> <i class="iconfont" v-bind:class="{'icon-good2':secondItemData.isLike == 1, 'icon-good3':secondItemData.isLike == 0}"></i>
                </span>
                <span v-if="!secondItemData.isDelete" class="com-famous-cic-comment" @click="clickReply">
                    <i class="iconfont icon-comment-1"></i>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
export default {
    name: 'FamousCommentItemSecond',
    props: {
        secondItemData: {
            type: Object,
            default() { return {} }
        },
        operateFunc: {
            type: Function,
            default() { return null }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            avatarUrl: require('../../assets/images/avatar.png'),
        }
    },
    methods: {
        clickMore() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('more', this.secondItemData)
            }
        },
        clickLike() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('like', this.secondItemData)
            }
        },
        clickReply() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('reply', this.secondItemData)
            }
        },
    }
}
</script>